// extracted by mini-css-extract-plugin
export default {"wrapper":"MultipleCustomOption_wrapper__5s7MQ","selected":"MultipleCustomOption_selected__AoFVH","half-checked":"MultipleCustomOption_half-checked__A2REf"};